import styled from "styled-components";
import { Card, Colors, Icon } from "@blueprintjs/core";
import { Box, CustomButton, Text, Avatar, TitleComponent } from "ui-components";

const ProfileCard = styled(Card)`
  position: relative;
  padding: 1rem;
  width: 100%;
  border-radius: 10px;
  margin: 15px 0px;
	box-shadow:  ${({ theme: { darkMode } }) =>darkMode ? "" :"unset !important" };
  filter: drop-shadow(0px 0px 10px rgba(0, 0, 0, 0.1));
  &:hover {
    // box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    // filter: drop-shadow(0px 0px 10px rgba(0, 0, 0, 0.1));
  }
`;

const LockButton = styled(CustomButton)`
  font-size: 13px;
  width:150px;
  padding:0px 12px 0px 10px !important;
  position: absolute;
  top: 10px;
  right: 10px;
  border: 1px solid
    ${({ theme: { darkMode } }) =>
      darkMode ? Colors.GRAY2 : Colors.LIGHT_GRAY2};
  border-radius: 15px;
  align-items: baseline;
  .bp5-button-text {
    margin-top: 4px;
  }
  .bp5-icon > svg {
    width: 12px !important;
    height: 12px !important;
  }
`;

type Props = {
  name?: string;
  profileImage?: string;
  emailId?: string;
  linkedin?: string;
  position?: string;
  degreeFrom?: string;
  priorInvestment?: string;
};

const TeamProfile = ({
  name,
  profileImage,
  emailId,
  linkedin,
  position,
  degreeFrom,
  priorInvestment,
}: Props) => {
  if (!name || name == "0") return;
  return (
    <ProfileCard key={name}>
      <Box flexDir="row">
        <Avatar
          email={"yantrix@gmail.com"}
          profileUrl={profileImage || emailId}
          displayName={name || "Josh Hanley"}
          onlyAvatar={true}
          isCircle={true}
          isCurrentUser={false}
          isLoading={false}
          size={"30px"}
        />

        <Box ml={"small"}>
          <Box flexDir="row" mt={"xsmall"}>
            <TitleComponent
              fontSize={"20px"}
              marginTop={"0px"}
              lineHeight={"unset"}
            >
              {name || "Josh Hanley"}
            </TitleComponent>
            {linkedin && linkedin !== "0" ? (
              <a href={linkedin} target="_blank">
                <img
                  src={"/icons/linkedin-square.svg"}
                  alt={""}
                  width={18}
                  height={18}
                  className={"ml-xs"}
                />
              </a>
            ) : null}
          </Box>

          <Text large className={"mt-xxs mb-xs"}>
            {position && position !== "0" ? position : "Co-Founder and CEO"}
          </Text>
          <Box flexDir="row" items="center">
            <Icon icon="learning" size={12} style={{ marginRight: "5px" }} />
            <Text small muted>
              {degreeFrom || "University of California, Berkeley"}
            </Text>
          </Box>
          <Text small muted>
            {priorInvestment || "Prior: Investment Partner at Dorm Room Fund"}
          </Text>
        </Box>
      </Box>
      <LockButton rightIcon="lock" minimal>
        Unlock Email
      </LockButton>
    </ProfileCard>
  );
};

export default TeamProfile;
